import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { Shared } from './shared.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ControlCanActivate implements CanActivate {
  
  constructor(private afAuth: AngularFireAuth, private router: Router, private shared: Shared){

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if(this.shared.guard_sub){
            return true;
        }
        let isAuth = new Observable<boolean>(observer => {
            this.afAuth.authState.subscribe(value => {
                this.shared.guard_sub = true;
                if(value != null){
                    this.shared.current_user = value;
                    observer.next(true);
                } else {
                    observer.next(false);
                    this.router.navigate(['']);
                    this.shared.guard_sub = false;
                    observer.complete();
                }
            });
        });
        return isAuth;
  }
}



// WEBPACK FOOTER //
// ./src/app/control-can-activate.guard.ts